import apiUsers from '@/api/users'
import {isEmpty, isNil, pipe, propOr, reject, unless} from 'ramda'

const state = {
  data: [],
  isLoading: false,
  error: null,
  total: null,
  lastPage: null,
}

export const mutationTypes = {
  getUsersStart: '[users] Get users start',
  getUsersSuccess: '[users] Get users success',
  getUsersFailure: '[users] Get users failure',
}

export const actionTypes = {
  getUsers: '[users] Get trainer',
}

const mutations = {
  [mutationTypes.getUsersStart](state) {
    state.isLoading = true
    state.error = null
    state.data = []
  },

  [mutationTypes.getUsersSuccess](state, payload) {
    if (payload.isAdd) {
      state.data = [...state.data, ...payload.list]
    } else {
      state.data = payload.list
    }

    state.total = payload.total
    state.lastPage = payload.lastPage
    state.isLoading = false
  },

  [mutationTypes.getUsersFailure](state, payload) {
    state.isLoading = false
    state.error = payload
  },
}

const actions = {
  [actionTypes.getUsers](context, data) {
    const params = pipe(
      propOr(null, 'params'),
      unless(isNil, reject(isEmpty))
    )(data)

    const isAdd = propOr(false, 'isAdd', data)
    context.commit(mutationTypes.getUsersStart)
    return new Promise((resolve) => {
      apiUsers
        .getUsers(params)
        .then((response) => {
          context.commit(mutationTypes.getUsersSuccess, {
            ...response.data,
            isAdd,
          })
          resolve(response.data)
        })
        .catch((error) => {
          context.commit(mutationTypes.getUsersFailure, error)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
